import React from 'react';
import { misc } from '../data.js';

export default function Miscellaneous({ sectionBg }) {
  const cardBg = sectionBg === "bg-gray-50" ? "bg-white" : "bg-gray-50";

  return (
     <section id="miscellaneous" className={sectionBg + ' py-16'}>
    <div className="max-w-6xl mx-auto px-6">
      <h2 className="text-3xl font-bold mb-8 text-center">Miscellaneous Activities</h2>
      <div className="space-y-6">
        {misc.map((item, index) => (
          <div key={index} className={`${cardBg} p-6 rounded-xl shadow-md hover:shadow-lg transition`}>
            <h3 className="text-xl font-semibold" dangerouslySetInnerHTML={{ __html: `${item.title} – ${item.organization}` }} />
            <p className="italic text-gray-500 mt-1" dangerouslySetInnerHTML={{ __html: item.date }} />
            {item.details?.length > 0 && (
              <ul className="list-disc list-inside mt-2 text-gray-700">
                {item.details.map((detail,i) => <li key={i} dangerouslySetInnerHTML={{ __html: detail }} />)}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
    </section>
  );
}
